interface NoImageIconProps {
  width?: number;
  height?: number;
  display_txt?: string;
}

export function NoImageIcon({ width = 150, height = 100, display_txt = 'No image' }: NoImageIconProps) {
  return (
    <svg
      className="bd-placeholder-img img-thumbnail"
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Placeholder image"
      preserveAspectRatio="xMidYMid slice"
      focusable="false"
    >
      <title>No image</title>
      <rect width="100%" height="100%" fill="#868e96" />
      <text x="50%" y="50%" fill="#dee2e6" fontSize="16" textAnchor="middle" dominantBaseline="middle">
        {display_txt}
      </text>
    </svg>
  );
}
